import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } 	from 'gsap/ScrollSmoother';
gsap.registerPlugin( ScrollTrigger, ScrollSmoother );

export default class {

    constructor(options) {

        // OPTIONS
        this.defaults = {

            $el: undefined,
            main: undefined

        }

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace  = 'home_landing_control';

		// DOM ELEMENT !!!!!!!!!!
		this.$el = this.options.$el;
		this.main = this.options.main;

		// vars
		this.$win 		= $(window);
		this.$doc 		= $(document);
		this.$html 		= $('html');
		this.$body 		= $( 'body' );


		this.ids = [];

		// init!!!!
		this.init( true );

    }

	init( b ){

		//console.log( 'initHomeLandingControl, b = ' + b  );

		this.previewActive = b;

		this.debounceResize( b, b);
		//this.initScrollTrigger(b);
		this.initMenuHover( b );

		this.initVideos();
		
		if ( b ){
			this.$el.addClass( 'ready' );
		}

	}


	//-----------------------------------------------------[  PREVIEW ]------------------------------------------------------------//
	initMenuHover( b ){

		if ( b ){
			$( '.top-right-bottom-left a' ).on( 'mouseenter', ( e )=>this.directorOnMouseEnter(e,true) );
			$( '.top-right-bottom-left a' ).on( 'mouseleave', ( e )=>this.directorOnMouseEnter(e,false) );

		}	
		else{
			$( '.top-right-bottom-left a' ).off( 'mouseenter', ( e )=>this.directorOnMouseEnter(e,true) );
			$( '.top-right-bottom-left a' ).off( 'mouseleave', ( e )=>this.directorOnMouseEnter(e,false) );

		}
	}

	directorOnMouseEnter(e,b){

		this.pauseHomeVideo( b );

	}


	initVideos(){
		let $video_home = this.$el.find( '.video-placeholder' );

		// check if home page has video thubnail, and defer loading the othger videos when loaded.
		if ( $video_home.length > 0 ){
			$video_home.find( '.video-player' ).on( 'video::play', ()=>{ 
				this.onVideoHomeReady();
			} );
		}
		else{
			this.onVideoHomeReady();
		}
	}

	onVideoHomeReady(){

		return;

		/*
		let i = this.backgrounds.length, background;
		while( i-- ){
			background = this.backgrounds[ i ];

			// load other videos
			if ( background.$script.length > 0 ){
				background.$video.html( background.$script.html() );
				this.main.WIDGETS.initVideoPlayer( true, background.$video );
			}
		}
		*/
	}

	pauseHomeVideo( b ){
		let $video_home = $( '.video-placeholder .video-player' ), videoPlayerInstance;
		if ( $video_home.length > 0 ){
			videoPlayerInstance = $video_home.data('widget');
			if ( videoPlayerInstance ){
				videoPlayerInstance.play( !b );
			}
		}
	}





	/*
	initScrollTrigger(b){
		if ( b ){
			let $slides = this.$el.find( '.home-promo-slide' ), $slide, $img, $video;
			if ( $slides.length > 0 ){
				$slides.each( ( i, el ) => {

					$slide  	= $(el);
					$img 		= $slide.find( '.display-inner' );

					// if video add listener to video play/pause
					if ( $slide.hasClass( 'is-video' ) ){

						$video = $slide.find( '.video-player' );
						this.initVideo( $video, true);
						
						this.videos[ this.videos.length ] = $video;
					}
					
					gsap.fromTo( $img, { y: $slide.height() - $img.height() },
						{
							y: 0,
							ease: "none",
							scrollTrigger: {
								trigger: $slide,
								start: "top bottom-=100px", // the default values
								end: "bottom top+=100px",
								scrub: true,
								markers: false, //i===0,
								id: this.getID(),
								// toggleClass: 'in-view'
							} 
						}
					);				
					
				})
			}
		}
		else{
			this.destroyScrollTriggers();
		}
	}
	*/

    debounceResize(b, resize){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 17 );
			$(window).on( 'resize', this._debResize );
			if ( resize ){
				this.onResize();
			}
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				$(window).off( 'resize', this._debResize );
			}        
		}
    }

    onResize(){

    }

	//--------------------- UTILS ----------------------//
	getID(){
		const id = 'id_' + this.namespace + '_' + this.ids.length;
		this.ids.push( id );
		return id;
	}

	killById( id ){
		if ( ScrollTrigger.getById( id ) ){
			ScrollTrigger.getById( id ).kill();
		}
	}

	destroyScrollTriggers(){
      	if ( this.ids.length ){
      		let i = this.ids.length;
      		while( i-- ){
      			this.killById( this.ids[i] );
      		}
      		this.ids = [];
      	}
	}

    destroy(){
		this.init( false );
    }

}